import { Route, Routes } from "react-router-dom";
import { QuoterColocaPage } from "./pages/QuoterColocaPage";

export const QuoterColocaNavigation = () => (
  <Routes>
    <Route index element={<QuoterColocaPage />} />
  </Routes>
);
